export default "__VITE_ASSET__4BgmA2Ag__"